import styled from "styled-components";

export const Icon = styled.div`
  width: 15px;
  height: 15px;
  background-image: url(${props => props.src});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  background-color: #fff;
  align-items: center;
  width: 100%;
  padding: 0px 5px;
  border-color: ${props => stageBorderColor(props.stage, props.showInCalendarAsScheduledInGreen, props.showInCalendarAsInProgressInGreen)};
  border-width: 1px;
  border-radius: 3px;
  border-style: solid;

  &:hover {
    background-color: ${props => stageHoverColor(props.stage, props.showInCalendarAsScheduledInGreen, props.showInCalendarAsInProgressInGreen)};
  }
`;

const stageBorderColor = (stage, showInCalendarAsScheduledInGreen, showInCalendarAsInProgressInGreen) => {
  if(stage === 'scheduled' && showInCalendarAsScheduledInGreen) {
    return '#19D950';
  }
  if(stage === 'scheduled' && !showInCalendarAsScheduledInGreen) {
    return '#0751CE';
  }

  if(stage === 'progress' && showInCalendarAsInProgressInGreen) {
    return '#19D950';
  }
  if(stage === 'progress' && !showInCalendarAsInProgressInGreen) {
    return '#0751CE';
  }

  switch(stage) {
    case 'done':
      return '#19D950';
    case 'overdue':
      return '#FF0000';
    case 'pending':
      return '#FF0000'
    case 'expired':
      return '#FF0000';
    default:
      return '#0751CE';
  }
}

const stageHoverColor = (color, showInCalendarAsScheduledInGreen, showInCalendarAsInProgressInGreen) => {
  if(color === 'scheduled' && showInCalendarAsScheduledInGreen) {
    return '#EEFFF6';
  }
  if(color === 'progress' && showInCalendarAsInProgressInGreen) {
    return '#EEFFF6';
  }

  switch(color) {
    case 'done':
      return '#EEFFF6';
    case 'overdue':
      return '#FFEEEE';
    case 'scheduled':
      return '#EEF7FF';
    case 'pending':
      return '#FFEEEE';
    case 'expired':
      return '#FFEEEE';
    default:
      return '#EEF7FF';
  }
}
